<template>
<div class="loading-spinner" v-if="isLoading">
  <div class="lds-spinner"
    ><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div
  ></div>
  <h3>{{ loadingMessage }}</h3>
</div>
</template>

<script>
import { mainComputed } from '@state/helpers';

export default {
  components: {},
  props: {
    isEmbed: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mainComputed,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.loading-spinner {
  align-items: center;
  background: $color-body-bg;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index: 9996;

  h3 {
    font-size: 1.7rem;
    font-weight: 600;
    line-height: 1.2;
    padding: 0 3rem;
    text-align: center;
  }

  .lds-spinner {
    display: inline-block;
    height: 6.4rem;
    margin-bottom: 2rem;
    position: relative;
    width: 6.4rem;

    div {
      animation: lds-spinner $duration-loading-spinner linear infinite;
      transform-origin: 3.2rem 3.2rem;

      &::after {
        background: $color-action;
        border-radius: $size-loading-spinner-border-radius;
        content: '';
        display: block;
        height: 1.3rem;
        left: 2.9rem;
        position: absolute;
        top: 0.3rem;
        width: 0.4rem;
      }

      &:nth-child(1) {
        animation-delay: -1.1s;
        transform: rotate(0deg);
      }

      &:nth-child(2) {
        animation-delay: -1s;
        transform: rotate(30deg);
      }

      &:nth-child(3) {
        animation-delay: -0.9s;
        transform: rotate(60deg);
      }

      &:nth-child(4) {
        animation-delay: -0.8s;
        transform: rotate(90deg);
      }

      &:nth-child(5) {
        animation-delay: -0.7s;
        transform: rotate(120deg);
      }

      &:nth-child(6) {
        animation-delay: -0.6s;
        transform: rotate(150deg);
      }

      &:nth-child(7) {
        animation-delay: -0.5s;
        transform: rotate(180deg);
      }

      &:nth-child(8) {
        animation-delay: -0.4s;
        transform: rotate(210deg);
      }

      &:nth-child(9) {
        animation-delay: -0.3s;
        transform: rotate(240deg);
      }

      &:nth-child(10) {
        animation-delay: -0.2s;
        transform: rotate(270deg);
      }

      &:nth-child(11) {
        animation-delay: -0.1s;
        transform: rotate(300deg);
      }

      &:nth-child(12) {
        animation-delay: 0s;
        transform: rotate(330deg);
      }
    }
  }

  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
}
</style>
